export const proposalTableData = [
    {
        "id": 1,
        "proposal": "#987456",
        "client": {
            "name": "Alexandra Della",
            "email": "alex.della@outlook.com",
            "img": "/images/avatar/1.png"
        },
        "subject": "A business proposal for a new product or service",
        "amount": "$249.99 USD",
        "date": "2023-04-25, 03:42PM",
        "status": {
            "content": "Sent",
            "color": "bg-soft-success text-success"
        }
    },
    {
        "id": 2,
        "proposal": "#987456",
        "client": {
            "name": "Nancy Elliot",
            "email": "nancy.elliot@outlook.com",
            "img": ""
        },
        "subject": "A funding proposal for a non-profit organization",
        "amount": "	$120.50 USD",
        "date": "2023-05-20, 12:23PM",
        "status": {
            "content": "Open",
            "color": "bg-soft-danger text-danger"
        }
    },
    {
        "id": 3,
        "proposal": "#741258",
        "client": {
            "name": "Green Cute",
            "email": "green.cute@outlook.com",
            "img": "/images/avatar/2.png"
        },
        "subject": "A research proposal for a scientific study",
        "amount": "	$300.50 USD",
        "date": "2023-01-02, 10:36AM",
        "status": {
            "content": "Sent",
            "color": "bg-soft-success text-success"
        }
    },
    {
        "id": 4,
        "proposal": "#321456",
        "client": {
            "name": "Henry Leach",
            "email": "henry.leach@outlook.com",
            "img": ""
        },
        "subject": "A marketing proposal for a new marketing campaign",
        "amount": "$249.99 USD",
        "date": "22023-04-25, 04:22PM",
        "status": {
            "content": "Draft",
            "color": "bg-gray-200 text-dark"
        }
    },
    {
        "id": 5,
        "proposal": "#357895",
        "client": {
            "name": "Marianne Audrey",
            "email": "marine.adrey@outlook.com",
            "img": "/images/avatar/3.png"
        },
        "subject": "A project proposal for a new construction project",
        "amount": "$150.00 USD",
        "date": "2023-02-15, 05:23PM",
        "status": {
            "content": "Sent",
            "color": "bg-soft-success text-success"
        }
    },
    {
        "id": 6,
        "proposal": "#321456",
        "client": {
            "name": "Alexandra Della",
            "email": "alex.della@outlook.com",
            "img": "/images/avatar/4.png"
        },
        "subject": "A educational proposal for a new course or program",
        "amount": "$249.99 USD",
        "date": "2023-04-25, 11:43AM",
        "status": {
            "content": "Paid",
            "color": "bg-soft-success text-success"
        }
    },
    {
        "id": 7,
        "proposal": "#987456",
        "client": {
            "name": "Nancy Elliot",
            "email": "nancy.elliot@outlook.com",
            "img": "/images/avatar/5.png"
        },
        "subject": "A event proposal for a conference or workshop",
        "amount": "$120.50 USD",
        "date": "2023-05-20, 03:46PM",
        "status": {
            "content": "Unpaid",
            "color": "bg-soft-danger text-danger"
        }
    },
    {
        "id": 8,
        "proposal": "#741258",
        "client": {
            "name": "Green Cute",
            "email": "green.cute@outlook.com",
            "img": "/images/avatar/6.png"
        },
        "subject": "A technology proposal for a new software or hardware solution",
        "amount": "$300.00 USD",
        "date": "2023-01-02, 02:35PM",
        "status": {
            "content": "Paid",
            "color": "bg-soft-success text-success"
        }
    },
    {
        "id": 9,
        "proposal": "#357895",
        "client": {
            "name": "Henry Leach",
            "email": "henry.leach@outlook.com",
            "img": ""
        },
        "subject": "An investment proposal for a new venture or start-up",
        "amount": "$249.99 USD",
        "date": "2023-04-25,06:35PM",
        "status": {
            "content": "Draft",
            "color": "bg-gray-200 text-dark"
        }
    },
    {
        "id": 10,
        "proposal": "#521456",
        "client": {
            "name": "Alexandra Della",
            "email": "alex.della@outlook.com",
            "img": "/images/avatar/4.png"
        },
        "subject": "A educational proposal for a new course or program",
        "amount": "$249.99 USD",
        "date": "2023-04-25, 11:43AM",
        "status": {
            "content": "Paid",
            "color": "bg-soft-success text-success"
        }
    },
    {
        "id": 11,
        "proposal": "#117456",
        "client": {
            "name": "Alexandra Della",
            "email": "alex.della@outlook.com",
            "img": ""
        },
        "subject": "A business proposal for a new product or service",
        "amount": "$249.99 USD",
        "date": "2023-04-25, 03:42PM",
        "status": {
            "content": "Sent",
            "color": "bg-soft-success text-success"
        }
    },
    {
        "id": 12,
        "proposal": "#351457",
        "client": {
            "name": "Alexandra Della",
            "email": "alex.della@outlook.com",
            "img": "/images/avatar/4.png"
        },
        "subject": "A educational proposal for a new course or program",
        "amount": "$249.99 USD",
        "date": "2023-04-25, 11:43AM",
        "status": {
            "content": "Paid",
            "color": "bg-soft-success text-success"
        }
    },
]